import { useState, useEffect } from "react";
import { Loader2, User, LogIn, ExternalLink } from "lucide-react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function DemoAccountsAdmin() {
  const [list, setList] = useState(null);
  const [busy, setBusy] = useState(null);
  const { impersonate } = useAuth();
  const navigate = useNavigate();

  useEffect(() => { api.get("/admin/demo-accounts").then(({ data }) => setList(data)).catch(() => setList([])); }, []);

  const actAs = async (u) => {
    setBusy(u.id);
    try {
      const { data } = await api.post(`/admin/impersonate/${u.id}`);
      await impersonate(data.token);
      toast.success(`Now acting as ${u.username || u.name}`);
      navigate("/profile");
    } catch { toast.error("Couldn't open that account"); setBusy(null); }
  };

  if (list === null) return <div className="flex justify-center py-16"><Loader2 className="animate-spin text-gold" size={26} /></div>;

  return (
    <div data-testid="demo-accounts-admin">
      <h2 className="font-heading font-black uppercase tracking-tight text-xl mb-1">Demo accounts</h2>
      <p className="text-sm text-[#A89F94] mb-4">Open any dummy account to post, edit and delete from their profile. Use the gold banner to switch back.</p>
      <div className="space-y-2">
        {list.map((u) => (
          <div key={u.id} className="flex items-center gap-3 bg-ink-900 border border-zinc-800 rounded-xl px-3 py-2.5" data-testid={`demo-${u.id}`}>
            <div className="w-10 h-10 rounded-full overflow-hidden bg-ink-800 shrink-0">{u.avatar_url ? <img src={u.avatar_url} alt="" className="w-full h-full object-cover" /> : <User size={16} className="m-auto mt-3 text-zinc-500" />}</div>
            <div className="flex-1 min-w-0">
              <div className="font-heading font-bold text-sm truncate">{u.username || u.name}</div>
              <div className="text-[11px] text-zinc-500 truncate">{u.email} · {u.posts} posts</div>
            </div>
            <button onClick={() => navigate(`/u/${u.id}`)} data-testid={`demo-open-${u.id}`} className="text-zinc-400 hover:text-gold p-2"><ExternalLink size={16} /></button>
            <button onClick={() => actAs(u)} disabled={busy === u.id} data-testid={`demo-actas-${u.id}`} className="flex items-center gap-1.5 bg-gold text-ink-950 font-heading font-bold text-xs rounded-full px-3 py-2 disabled:opacity-60">
              {busy === u.id ? <Loader2 size={14} className="animate-spin" /> : <LogIn size={14} />} Act as
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
